import React, { useEffect, useState } from "react";
import ProfileDetailsView from "./ProfileDetailsView";
import {
  get_profile_byid,
  get_matches_for_client,
  get_access_request,
  check_access_request,
  send_access_request,
} from "../api/serverWrapper";
import { getData } from "../utils/store-data";
import { AGENT_LOGIN, USER_ID } from "../utils/store-data-constants";
import { useMasterData } from "../context/MasterDataContext";
import logo from "../assests/images/menubar_logo.png";

const DashboardProfileView = ({ profileId, onClose }) => {
  const {
    religionMasterData,
    maritalStatusMasterData,
    skinToneMasterData,
    buildMasterData,
    habitsMasterData,
    hobbiesMasterData,
    qualificationMasterData,
    languageMasterData,
    relationsMasterData,
  } = useMasterData();

  const [UserData, setUserData] = useState(null);
  const [AccesRequestStatus, setAccesRequestStatus] = useState(null);
  const [CheckAccesRequestStatus, setCheckAccesRequestStatus] = useState(null);

  const [isAgentLogin, setIsAgentLogin] = useState(true);
  const [UserId, setUserId] = useState(null);

  const [languages] = useState(languageMasterData || []);
  const [qualifications] = useState(qualificationMasterData || []);
  const [relationList] = useState(relationsMasterData || []);
  const [habitList] = useState(habitsMasterData || []);
  const [hobbiesList] = useState(hobbiesMasterData || []);

  const [selectedQualification, setSelectedQualification] = useState(null);
  const [casteName, setCasteName] = useState("");

  useEffect(() => {
    loadData();
  }, [profileId]);

  const loadData = async () => {
    let agent = await getData(AGENT_LOGIN);
    let userId = await getData(USER_ID);

    setIsAgentLogin(agent);
    setUserId(userId);

    let resp = await get_profile_byid(profileId);
    let data = resp?.data[0];

    setUserData(data);
    setSelectedQualification(data?.QualificationId);

    // Access request logic
    await getAccesRequest(userId, profileId);
    await checkAccess(profileId, userId);
  };

  const getAccesRequest = async (ProfileId, ToProfileId) => {
    let resp = await get_access_request(ProfileId, ToProfileId);
    setAccesRequestStatus(resp?.data?.IsAccepted);
  };

  const checkAccess = async (ProfileId, ToProfileId) => {
    let resp = await check_access_request(ToProfileId, ProfileId);
    setCheckAccesRequestStatus(resp?.data);
  };

  const approveTheRequest = async () => {
    let data = {
      RequestId: CheckAccesRequestStatus.RequestId,
      ProfileId: UserId,
      ToProfileId: UserData.ProfileId,
      IsAccepted: 2,
    };

    await send_access_request(data);
    loadData();
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(UserData?.ClientCode);
  };

  const openModal = () => {};
  const sendAccessRequest = () => {};

  const getReligionNameById = (id) => {
    const found = religionMasterData.find((i) => i.ReligionId === id);
    return found?.ReligionName || "";
  };

  const getCityName = (city) => city || "";

  const getMaritalStatusNameById = (id) => {
    const found = maritalStatusMasterData.find(
      (i) => i.MarriageStatusId === id,
    );
    return found?.MarriageStatus || "";
  };

  const getBuildNameById = (id) => {
    const found = buildMasterData.find((i) => i.BuildId === id);
    return found?.BuildName || "";
  };

  const getSkinToNameById = (id) => {
    const found = skinToneMasterData.find((i) => i.SkinToneId === id);
    return found?.SkinToneName || "";
  };

  if (!UserData)
    return (
      <div className="loading-screen">
        <img src={logo} alt="Logo" className="logo-3d" />
      </div>
    );

  return (
    <div>
      <ProfileDetailsView
        UserData={UserData}
        client={UserData}
        navigate={() => {}}
        AccesRequestStatus={AccesRequestStatus}
        CheckAccesRequestStatus={CheckAccesRequestStatus}
        approveTheRequest={approveTheRequest}
        handleCopy={handleCopy}
        openModal={openModal}
        sendAccessRequest={sendAccessRequest}
        isAgentLogin={isAgentLogin}
        UserId={UserId}
        relationList={relationList}
        qualifications={qualifications}
        selectedQualification={selectedQualification}
        habitList={habitList}
        hobbiesList={hobbiesList}
        casteName={casteName}
        languages={languages}
        getReligionNameById={getReligionNameById}
        getCityName={getCityName}
        getMaritalStatusNameById={getMaritalStatusNameById}
        getBuildNameById={getBuildNameById}
        getSkinToNameById={getSkinToNameById}
        showBack
        onBack={onClose}
      />
    </div>
  );
};

export default DashboardProfileView;
